import { Typography } from '@mui/material';
import Shop from '../components/Shop';

function ShopPage() {
    return (
        <>
            {/* <Typography variant="h4" gutterBottom>Shop</Typography>
            <Typography>Happy shopping!</Typography> */}
            <Shop />
        </>
    );
}

export default ShopPage;
